import {
  CalendarOutlined,
  CheckCircleFilled,
  ClockCircleOutlined,
  FireOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { Col, Row, Space, Tag } from 'antd';

import Text from '../../../components/Text';
import { momentTimezone } from '../../../utils/common';
import TimelineBox from '../TimelineBox';
import classNames from './styles.module.scss';

const getNextDeadlineTag = (nextDeadline, t) => {
  if (!nextDeadline) return null;

  const isCritical = nextDeadline.daysUntil <= 1;
  const isWarning = nextDeadline.daysUntil <= 3;

  return (
    <Tag
      color={isCritical ? 'red' : isWarning ? 'orange' : 'gold'}
      icon={
        isCritical ? <FireOutlined /> : isWarning ? <WarningOutlined /> : <ClockCircleOutlined />
      }
    >
      {nextDeadline.daysUntil === 0 ? t('today') : t('daysLeft', { count: nextDeadline.daysUntil })}
    </Tag>
  );
};

const EventTimeline = props => {
  const { t, timeline, groupId, fromDate, toDate, nextDeadline } = props;

  if (!Array.isArray(timeline) || !timeline.length) {
    return null;
  }

  const nowTs = momentTimezone().unix();

  return (
    <div className={classNames.eventTimeline}>
      <Row
        align="middle"
        justify="space-between"
        gutter={[12, 12]}
        className={classNames.timelineHeader}
      >
        <Col>
          <Text variant="strong">{t('nextDeadline')}</Text>
        </Col>

        {nextDeadline ? (
          <Col>
            <Space size={8} wrap>
              <Text variant="strong" className={classNames.nextDeadlineLabel}>
                {nextDeadline.label}
              </Text>
              <Text className={classNames.headerText}>{nextDeadline.dateLabel}</Text>
              {getNextDeadlineTag(nextDeadline, t)}
            </Space>
          </Col>
        ) : (
          <Col>
            <Text className={classNames.headerText}>{t('noUpcomingDeadlines')}</Text>
          </Col>
        )}
      </Row>

      <div className={classNames.timelineScroller}>
        <div className={classNames.timelineColumns}>
          {timeline.map((item, index) => {
            const itemTs = momentTimezone(item.date).unix();
            const isDone = nowTs >= itemTs;
            const isLast = index === timeline.length - 1;

            return (
              <div key={[item.type, item.date].join('-')} className={classNames.stepCol}>
                <div className={classNames.stepHead}>
                  <div
                    className={[
                      classNames.stepIcon,
                      isDone ? classNames.stepIconDone : classNames.stepIconPending,
                    ].join(' ')}
                  >
                    {isDone ? <CheckCircleFilled /> : <ClockCircleOutlined />}
                  </div>

                  {!isLast && <div className={classNames.stepConnector} />}

                  <div className={classNames.stepMeta}>
                    <span className={classNames.stepTitle}>{t(item.type)}</span>
                    <Tag icon={<CalendarOutlined />} className={classNames.stepDateTag}>
                      {momentTimezone(item.date).format('MMM D, YYYY')}
                    </Tag>
                  </div>
                </div>

                <div className={classNames.cardSlot}>
                  <TimelineBox
                    t={t}
                    timelineItem={item}
                    groupId={groupId}
                    fromDate={fromDate}
                    endDate={toDate}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

EventTimeline.defaultProps = {
  timeline: [],
};

export default EventTimeline;
